import type {QuizContextMenuProps} from '../../elements/context-menu/quiz/QuizContextMenu';
import {QuizModelType} from "@stores/quiz/QuizModel"

import {AppState} from "@stores/AppState";



export type OpenQuizContextMenuParams = Partial<QuizContextMenuProps>


export const openQuizContextMenu = (
    appState: AppState,
    quizMST: QuizModelType,
    mousePositionParams: any,
    additionalParams?: OpenQuizContextMenuParams,
) => {
    appState.setContextMenu(
        {
            ...mousePositionParams,
            minWidth: 285,
            type: 'quiz',
            menuAlignment: 'end',
            withOverlay: true,
            params: {
                quizId: quizMST.id,
                quizMST: quizMST,
                ...additionalParams,
            },
        },
    )
}